import { IS_IOS } from '@weblite/logic-toolkit'
import { IS_SAFARI } from '$func/environmentInfo'

export interface OnboardingAction {
  action: string
  time: string
}

export enum IosSafariOnboarding {
  IOS_SYNC_CONTACTS = 'iOSSyncContacts',
}

export enum CommonOnboarding {
  CREATE_ROOM_FAB = 'createRoomFab',
  CHAT_WAPP_BUTTON = 'chatWappButton',
  HALL_APP_BAR_CALL_BUTTON = 'hallAppbarCallButton',
  CREATE_CHANNEL_BUTTON = 'createChannelButton',
  COURSE_VITRINE_SETTING_BUTTON = 'courseVitrineSettingButton',
}

export type IOnboarding = CommonOnboarding | IosSafariOnboarding

export interface ActionsState {
  actions: Set<string>
  fetched: boolean
}

export const onboardingActions = [
  ...Object.values(CommonOnboarding || {}),
  ...(IS_IOS && IS_SAFARI ? Object.values(IosSafariOnboarding) : []),
]
